import React from "react";

import { Player } from "@lottiefiles/react-lottie-player";
import ToggleFaq from "../ToggleFaq";
import faq from "./faqs.json";

const index = () => {
  return (
    <div>
      <main>
        <div className="bg-gt5">
          {/* hero section starts here */}
          <section className="relative md:py-14 py-10 border-t border-white">
            <div className="md:max-w-7xl mx-auto max-w-md">
              <div className="relative">
                <div className="flex justify-between items-center px-5 w-full mb-8">
                  <div>
                    <p className="text-[11px] leading-[13px] font-normal text-black40 mb-1.5">
                      Network partner
                    </p>
                    <span
                      className="bg-no-repeat bg-contain w-[88px] h-5 md:w-[120px] md:h-[30px] inline-block"
                      style={{
                        backgroundImage:
                          "url(/assets/images/edge-website/rupay-logo.png)",
                      }}
                    ></span>
                  </div>
                  <div>
                    <p className="text-[11px] leading-[13px] font-normal text-black40 mb-1.5">
                      Issued by
                    </p>
                    <span
                      className="bg-no-repeat bg-contain w-[65px] h-5 md:w-[100px] md:h-[30px] inline-block"
                      style={{
                        backgroundImage:
                          "url(/assets/images/edge-website/csb-logo.jpg)",
                      }}
                    ></span>
                  </div>
                </div>

                <div className="w-full h-auto max-w-[690px] mx-auto mb-8">
                  <Player
                    autoplay
                    loop
                    src={"/assets/lottie/rupay-credit-card.json"}
                    style={{ height: "100%", width: "100%" }}
                  />
                </div>
                <div className="w-full px-5 md:text-center">
                  <h1 className="text-[40px] leading-[44px] font-bold text-gt75 mb-2 md:text-[40px] md:leading-[44px] md:mb-2">
                    The 3-in-1 RuPay Credit Card
                  </h1>
                  <p className="text-base font-medium leading-5 text-white md:text-2xl md:leading-8">
                    Switch between shopping, travel and dining
                  </p>
                  <span className="h-0.5 md:w-[350px] w-full bg-linear-gray mt-4 mb-7 inline-block align-top"></span>
                  <p className="text-sm md:text-base font-medium leading-5 text-white mb-7">
                    2% cashback • Lifetime free
                  </p>
                </div>
              </div>
            </div>
          </section>
          {/* hero section end here */}

          {/* The credit card you switch starts here */}
          <section className="px-4 py-8 bg-black5 md:py-28 text-left">
            <div className="md:max-w-7xl max-w-md mx-auto">
              <div className="mb-12 text-left">
                <h2 className="text-[32px] font-bold leading-9 text-gt75 mb-2 md:text-[40px] md:leading-[44px] md:mb-0">
                  The credit card you switch
                </h2>
                <span className="w-7 h-[7px] bg-gt75 inline-block md:w-16 md:h-2.5"></span>
              </div>
              <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-black5 py-6 px-5 rounded-2xl relative overflow-hidden mb-5">
                  <span className="text-sm leading-4 md:text-lg font-normal md:leading-[22px] text-black20">
                    Buying anything?
                  </span>
                  <h3 className="text-xl leading-8 md:text-[32px] font-semibold md:leading-[44px] text-[#2CB6A0] mb-1 tracking-[-4%]">
                    Switch to Shopping
                  </h3>
                  <p className="text-base font-normal leading-5 text-black40 mb-3">
                    2% cashback on fashion, groceries, <br />
                    electronics, and more
                  </p>
                  <span className="block absolute top-0 right-0 w-16 h-16 bg-[#54867D] rounded-full blur-3xl"></span>
                  <span className="block absolute bottom-0 left-0 w-16 h-16 bg-[#54867D] rounded-full blur-3xl"></span>
                  <span
                    className="absolute -bottom-4 -right-2.5 bg-no-repeat bg-contain w-[100px] h-[100px] opacity-20"
                    style={{
                      backgroundImage:
                        "url(/assets/images/edge-website/icons/shopping-mode.svg)",
                    }}
                  ></span>
                </div>
                <div className="bg-black5 py-6 px-5 rounded-2xl relative overflow-hidden mb-5">
                  <span className="text-sm leading-4 md:text-lg font-normal md:leading-[22px] text-black20">
                    Planning a vacation?
                  </span>
                  <h3 className="text-xl leading-8 md:text-[32px] font-semibold md:leading-[44px] text-[#9783DB] mb-1 tracking-[-4%]">
                    Switch to Travel
                  </h3>
                  <p className="text-base font-normal leading-5 text-black40 mb-3">
                    2% cashback on flights, trains, <br />
                    hotels, and more
                  </p>
                  <span className="block absolute top-0 right-0 w-16 h-16 bg-[#AEA3F1] rounded-full blur-3xl"></span>
                  <span className="block absolute bottom-0 left-0 w-16 h-16 bg-[#AEA3F1] rounded-full blur-3xl"></span>
                  <span
                    className="absolute -bottom-4 -right-2.5 bg-no-repeat bg-contain w-[100px] h-[100px] opacity-20"
                    style={{
                      backgroundImage:
                        "url(/assets/images/edge-website/icons/travel-plan.svg)",
                    }}
                  ></span>
                </div>
                <div className="bg-black5 py-6 px-5 rounded-2xl relative overflow-hidden mb-5">
                  <span className="text-sm leading-4 md:text-lg font-normal md:leading-[22px] text-black20">
                    Dining out?
                  </span>
                  <h3 className="text-xl leading-8 md:text-[32px] font-semibold md:leading-[44px] text-[#F18973] mb-1 tracking-[-4%]">
                    Switch to Dining
                  </h3>
                  <p className="text-base font-normal leading-5 text-black40 mb-3">
                    2% cashback on food delivery, <br />
                    restaurants, and more
                  </p>
                  <span className="block absolute top-0 right-0 w-16 h-16 bg-[#A47267] rounded-full blur-3xl"></span>
                  <span className="block absolute bottom-0 left-0 w-16 h-16 bg-[#A47267] rounded-full blur-3xl"></span>
                  <span
                    className="absolute -bottom-4 -right-2.5 bg-no-repeat bg-contain w-[100px] h-[100px] opacity-20"
                    style={{
                      backgroundImage:
                        "url(/assets/images/edge-website/icons/dining-mode.svg)",
                    }}
                  ></span>
                </div>
              </div>
            </div>
          </section>
          {/* The credit card you switch end here */}

          {/* Rewards on every spend start from here */}
          <section className="w-full bg-black5 text-left">
            <div className="md:max-w-7xl max-w-md mx-auto">
              <div className="w-full py-8 md:flex md:py-28 px-4 gap-4">
                <div className="md:w-1/2 w-full mb-14 md:mb-0">
                  <div>
                    <div className="mb-3 md:mb-8">
                      <h2 className="text-[32px] font-bold leading-9 text-gt75 md:text-[40px] md:leading-[44px]">
                        Rewards on every credit card spend
                      </h2>
                      <span className="w-7 h-[7px] bg-gt75 inline-block md:w-11 md:h-2.5"></span>
                    </div>
                    <div className="flex items-center">
                      <span
                        className="bg-no-repeat bg-contain flex-shrink-0 w-6 h-6 mr-7 md:w-9 md:h-9 hidden md:block mb-2.5"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/star-point.svg)",
                        }}
                      ></span>
                      <div className="border-b border-black80 md:py-10 py-5">
                        <h3 className="text-xl font-semibold leading-8 text-gt40 md:text-[32px] md:leading-[44px]">
                          Assured 2% cashback
                        </h3>
                        <p className="text-base leading-6 md:text-2xl font-medium md:leading-8 text-black40">
                          On either shopping, travel, or dining
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <span
                        className="bg-no-repeat bg-contain flex-shrink-0 w-6 h-6 mr-7 md:w-9 md:h-9 hidden md:block mb-2.5"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/star-point.svg)",
                        }}
                      ></span>
                      <div className="border-b border-black80 md:py-10 py-5">
                        <h3 className="text-xl font-semibold leading-8 text-gt40 md:text-[32px] md:leading-[44px]">
                          Assured 0.4% cashback
                        </h3>
                        <p className="text-base leading-6 md:text-2xl font-medium md:leading-8 text-black40">
                          On all other UPI and credit card spends
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <span
                        className="bg-no-repeat bg-contain flex-shrink-0 w-6 h-6 mr-7 md:w-9 md:h-9 hidden md:block mb-2.5"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/star-point.svg)",
                        }}
                      ></span>
                      <div className="md:py-10 py-5">
                        <h3 className="text-xl font-semibold leading-8 text-gt40 md:text-[32px] md:leading-[44px]">
                          Welcome rewards
                        </h3>
                        <p className="text-base leading-6 md:text-2xl font-medium md:leading-8 text-black40">
                          Worth ₹250 on your UPI & card spends
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="md:w-1/2 w-full">
                  <div className="lg:pl-20 md:w-[522px] max-w-md mx-auto md:max-w-full">
                    <div className="md:mb-24 mb-5">
                      <h2 className="text-[32px] font-bold leading-9 text-gt75 md:text-[40px] md:leading-[44px]">
                        It’s lifetime free
                      </h2>
                      <span className="w-7 h-[7px] bg-gt75 inline-block md:w-11 md:h-2.5"></span>
                    </div>
                    <img
                      className="md:w-full"
                      src={"/assets/images/edge-website/annual-free-detail.png"}
                      width="276"
                      alt="Annual Free"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/*  Rewards on every spend end here */}

          {/*  Ease of UPI start from here */}
          <section className="md:py-20 py-10 px-4 text-left">
            <div className="md:max-w-7xl mx-auto max-w-md relative">
              <div className="md:flex md:justify-between md:items-center">
                <div className="w-full md:w-1/2 mb-8 md:mb-0">
                  <h2 className="text-[32px] font-bold leading-9 text-gt75 mb-2 md:text-[40px] md:leading-[44px] md:mb-2">
                    Ease of UPI. <br />
                    On a credit card
                  </h2>
                  <span className="w-8 h-[7px] bg-gt75 inline-block md:w-14 md:h-2.5 mb-8"></span>
                  <p className="text-base font-medium leading-5 text-white md:text-2xl md:leading-8">
                    Scan & Pay any QR to make UPI payments with your Edge CSB
                    Bank RuPay Credit Card
                  </p>
                </div>

                <div className="w-full md:w-[38%] pr-1 pb-4 md:pb-0 md:pr-10">
                  <Player
                    autoplay
                    loop
                    src={"/assets/lottie/ease-of-use.json"}
                    style={{ height: "100%", width: "100%" }}
                  />
                </div>
              </div>
            </div>
          </section>
          {/*  Ease of UPI end here */}

          {/*  Take control start from here */}
          <section className="md:py-36 py-10 px-4 bg-black text-left">
            <div className="md:max-w-7xl mx-auto max-w-md relative">
              <div className="md:flex md:justify-between md:items-center">
                <div className="w-full md:w-2/5 mb-8 md:mb-0">
                  <h2 className="text-[32px] font-bold leading-9 text-gt75 mb-2 md:text-[40px] md:leading-[44px] md:mb-2">
                    Take control of the <br />
                    out-of-control
                  </h2>
                  <span className="w-8 h-[7px] bg-gt75 inline-block md:w-14 md:h-2.5 mb-8"></span>
                  <p className="text-base font-medium leading-5 text-white md:text-2xl md:leading-8">
                    Get Insights on both UPI and <br />
                    credit card spends
                  </p>
                </div>
                <div className="w-full md:w-[46%] pr-1 pb-4 bg-black md:bg-transparent md:pb-0 md:pr-10">
                  <img
                    className="w-full h-auto"
                    src={"/assets/images/edge-website/tracking-upi.png"}
                    alt="Tracking UPI"
                  />
                </div>
              </div>
            </div>
          </section>
          {/* Take control end here  */}

          {/*  1-click card start from here  */}
          <section className="relative md:py-44 py-9 px-4 text-left">
            <div className="md:max-w-7xl mx-auto max-w-md">
              <div>
                <div className="mb-8 md:mb-24">
                  <h2 className="text-[32px] font-bold leading-9 text-gt75 mb-2 md:text-[40px] md:leading-[44px] md:mb-2">
                    1-click card controls
                  </h2>
                  <span className="w-8 h-[7px] bg-gt75 inline-block md:w-14 md:h-2.5"></span>
                </div>
                <div className="w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                  <div className="flex items-center">
                    <span className="w-11 h-11 md:w-[88px] md:h-[88px] mr-3.5 bg-gt15 rounded-full border-[2px] border-gt25 flex-shrink-0 flex items-center justify-center">
                      <span
                        className="bg-no-repeat bg-contain w-6 h-6 md:w-11 md:h-11"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/copy.svg)",
                        }}
                      ></span>
                    </span>
                    <p className="text-sm font-medium leading-4 text-black20 md:text-[23px] md:leading-[30px]">
                      Copy number
                    </p>
                  </div>
                  <div className="flex items-center">
                    <span className="w-11 h-11 md:w-[88px] md:h-[88px] mr-3.5 bg-gt15 rounded-full border-[2px] border-gt25 flex-shrink-0 flex items-center justify-center">
                      <span
                        className="bg-no-repeat bg-contain w-6 h-6 md:w-11 md:h-11"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/snowflake-freeze.svg)",
                        }}
                      ></span>
                    </span>
                    <p className="text-sm font-medium leading-4 text-black20 md:text-[23px] md:leading-[30px]">
                      Freeze card &nbsp;&nbsp;
                    </p>
                  </div>
                  <div className="flex items-center">
                    <span className="w-11 h-11 md:w-[88px] md:h-[88px] mr-3.5 bg-gt15 rounded-full border-[2px] border-gt25 flex-shrink-0 flex items-center justify-center">
                      <span
                        className="bg-no-repeat bg-contain w-6 h-6 md:w-11 md:h-11"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/lock-with-pin.svg)",
                        }}
                      ></span>
                    </span>
                    <p className="text-sm font-medium leading-4 text-black20 md:text-[23px] md:leading-[30px]">
                      Reset PIN
                    </p>
                  </div>
                  <div className="flex items-center">
                    <span className="w-11 h-11 md:w-[88px] md:h-[88px] mr-3.5 bg-gt15 rounded-full border-[2px] border-gt25 flex-shrink-0 flex items-center justify-center">
                      <span
                        className="bg-no-repeat bg-contain w-6 h-6 md:w-11 md:h-11"
                        style={{
                          backgroundImage:
                            "url(/assets/images/edge-website/icons/manage-transactions.svg)",
                        }}
                      ></span>
                    </span>
                    <p className="text-sm font-medium leading-4 text-black20 md:text-[23px] md:leading-[30px]">
                      Card limits
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* 1-click card end here */}

          {/* FAQs start here */}
          <div className="py-12 sm:py-12 px-3 ">
            <h3 className="text-center text-lg text-white sm:text-4xl font-semibold mb-3 sm:mb-9">
              Frequently asked questions
            </h3>

            <div className="max-w-[1200px] mx-auto">
              <ToggleFaq questions={faq} />
            </div>
          </div>
          {/*  FAQs end here */}

          {/* footer start from here  */}
          <footer>
            <div className="md:flex md:items-center">
              <a
                href="https://www.csb.co.in/pdf/Edge-CSB-Bank-RuPay-Credit-Card-MITC_23rd-Sep-2024.pdf"
                className="w-full py-5 md:pl-28 pl-8 pr-8 bg-sf60 text-white text-lg leading-8 font-semibold flex justify-between items-center border-b md:border-r border-sf100 md:w-1/2"
              >
                <span>MITC</span>
                <span
                  className="bg-no-repeat bg-contain w-[12px] h-[18px] inline-block"
                  style={{
                    backgroundImage:
                      "url(/assets/images/edge-website/icons/right-chevron.svg?v=95c26f5b3c)",
                  }}
                ></span>
              </a>
              <a
                href="https://www.csb.co.in/pdf/Key_Fact_Statement_Edge_CSB_Bank_Credit_Card_12042024.pdf"
                className="w-full py-5 px-8 bg-sf60 text-white text-lg leading-8 font-semibold flex justify-between items-center border-b md:border-r border-sf100 md:w-1/2"
              >
                <span> Key Fact Statement</span>
                <span
                  className="bg-no-repeat bg-contain w-[12px] h-[18px] inline-block"
                  style={{
                    backgroundImage:
                      "url(/assets/images/edge-website/icons/right-chevron.svg?v=95c26f5b3c)",
                  }}
                ></span>
              </a>
              <a
                href="https://www.csb.co.in/pdf/Edge_CSB_Bank_Credit_Card-Terms_and_Conditions_12042024.pdf"
                className="w-full py-5 md:pr-28 pr-8 pl-8 bg-sf60 text-white text-lg leading-8 font-semibold flex justify-between items-center border-b border-sf100 md:w-1/2"
              >
                <span> Terms &amp; Conditions</span>
                <span
                  className="bg-no-repeat bg-contain w-[12px] h-[18px] inline-block"
                  style={{
                    backgroundImage:
                      "url(/assets/images/edge-website/icons/right-chevron.svg?v=95c26f5b3c)",
                  }}
                ></span>
              </a>
            </div>
            <div className="md:max-w-6xl max-w-md mx-auto px-4 text-left">
              <div className="md:flex pt-10 md:pt-[68px]">
                <div className="md:w-1/2 md:mt-10">
                  <div className="max-w-md">
                    <span
                      className="bg-no-repeat bg-contain w-[286px] h-[37px] inline-block mb-4 lg:w-[435px] lg:h-[57px]"
                      style={{
                        backgroundImage:
                          "url(/assets/images/edge-website/csb-edge.png)",
                      }}
                    ></span>
                    <p className="py-2 border-y border-[#ABABAB] text-black20 text-xl font-normal leading-[22px] mb-6 md:py-3 md:text-2xl md:leading-[30px] md:mb-9">
                      Built with trust at its core
                    </p>
                    <p className="text-black20 text-base font-normal leading-[22px] mb-7 md:text-2xl md:leading-[30px] md:mb-0">
                      Use the Edge CSB Bank RuPay Credit Card on Jupiter, the
                      app for everything money: Spend. Track. Save. Invest
                    </p>
                  </div>
                </div>
                <div className="text-center md:w-1/2">
                  <img
                    className="inline-block w-[300px] lg:w-[400px]"
                    src={"/assets/images/edge-website/edge-upi-mock.png"}
                    width="300"
                    alt="footer"
                  />
                </div>
              </div>
            </div>
            <div className="w-full -mt-10 md:-mt-20">
              <img
                loading="lazy"
                src={"/assets/images/bg_footer.svg"}
                alt="bg_footer"
                className="relative w-full mx-auto lg:static h-[116px] object-cover"
                style={{ bottom: -5 }}
              />
            </div>
            <div
              className="relative px-4 pb-6 text-white bg-sf50"
              style={{ top: -1 }}
            >
              <div className="md:max-w-6xl max-w-md mx-auto px-4">
                <p className="pb-2 text-xs font-normal leading-4 md:text-base md:leading-7 md:text-left">
                  The Edge brand is owned by Europa Neo Marketing Pvt Limited
                  ("ENMPL"). ENMPL has partnered with CSB Bank for the Edge CSB
                  Bank Rupay Credit card ("Credit Card"). The sole issuer of the
                  Credit Card is CSB Bank. ENMPL acts exclusively as a
                  co-branding partner and is responsible only for promoting the
                  Credit Card in the capacity of a co-branding partner. ENMPL
                  does not have visibility into or any role in, the approval
                  process for Credit Card applications, which are solely
                  governed by CSB Bank's eligibility criteria and Credit Card
                  policy. Additionally, ENMPL does not have any role and
                  visibility to Credit Card details, Credit Card management,
                  Credit Card transaction data and rewards and its role is
                  strictly limited only to promote the Credit Card on various
                  platforms.
                </p>
              </div>
            </div>
          </footer>
          {/* footer end here  */}
        </div>
      </main>
    </div>
  );
};

export default index;
